import { useQuery } from '@tanstack/react-query';
import { GetPlanningSessionResponse, getSpacePlanningSession } from '../api/planning.api';
import { useGetActualSpaceId } from './workspace';
import { QUERY_CONFIG } from '../constants/queryConfig';

export const usePlanningSession = () => {
  const spaceId = useGetActualSpaceId();

  return useQuery<GetPlanningSessionResponse, Error>({
    queryKey: ['workspacePlanningSession', parseInt(spaceId as string)],
    queryFn: async () => {
      const planningSession = await getSpacePlanningSession(parseInt(spaceId as string));
      return planningSession.data;
    },
    enabled: !!spaceId,
    staleTime: QUERY_CONFIG.STALE_TIME,
  });
};

export const usePlanningSessionById = (spaceId: number | null) => {
  return useQuery<GetPlanningSessionResponse, Error>({
    queryKey: ['workspacePlanningSession', spaceId],
    queryFn: async () => {
      const planningSession = await getSpacePlanningSession(spaceId!);
      return planningSession.data as unknown as GetPlanningSessionResponse;
    },
    enabled: !!spaceId,
    staleTime: QUERY_CONFIG.STALE_TIME,
  });
};
